import { Carrier, Utils } from 'common';
import React from 'react';

const { AddUpsCarrier, AddDhlxAccount, AddFedExAccount } = Carrier;
const { Session, Util } = Utils;

const AddCarrierWithCallback = ({ carrierName = '' }) => {
	const { AllowedTargetOrigin } = Session.getSettings();

	const completionCallback = (success, carrier, transferAuth) => {
		if (Session.getSettings().IsInWinClient) {
			window.close();
		} else {
			try {
				Util.postMessage(
					{ type: 'Carrier', success, carrier, transferAuth },
					AllowedTargetOrigin
				);
			} catch (error) {
				console.log(error);
			}
		}
	};

	if (carrierName === 'ups') {
		return <AddUpsCarrier completionCallback={completionCallback} />;
	}

	if (carrierName === 'fedex') {
		return (
			<AddFedExAccount
				completionCallback={completionCallback}
				showSuccessModal={true}
			/>
		);
	}

	if (carrierName === 'dhlexpress') {
		return <AddDhlxAccount completionCallback={completionCallback} />;
	}

	return null;
};

export default AddCarrierWithCallback;
